import type { ChangeEvent, FC } from 'react';
import { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import useRulePageMode from '../../hooks/useRulePageMode';
import useCurrentTasksFormStore from '../../hooks/useCurrentTasksFormStore';
import { Box, styled, TextField, Typography } from '@mui/material';
import type { ConditionVariantProps } from '../../types';

const TextFieldMultiplayerStyled = styled(TextField)({
  '& .MuiOutlinedInput-root': { maxHeight: 36, minHeight: 36, borderRadius: 0 },
  '& fieldset': { border: 'none', top: 0 },
  '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
    display: 'none',
  },
});

export const ConditionMultiplayer: FC<ConditionVariantProps> = observer(
  ({ indexTask, indexCondition, field, indexVariant }) => {
    const { isRead } = useRulePageMode();
    const tasksFormStore = useCurrentTasksFormStore();
    const isVariant = typeof indexVariant === 'number';

    const handleChangeMultiplayer = useCallback(
      (e: ChangeEvent<HTMLInputElement>) => {
        if (isVariant) {
          tasksFormStore.setVariantOnTaskConditionMetric(
            indexTask,
            indexVariant,
            indexCondition,
            field,
            e.target.value
          );
        } else {
          tasksFormStore.setConditionMetric(indexTask, indexCondition, field, e.target.value);
        }
      },
      [isVariant, tasksFormStore, indexTask, indexVariant, indexCondition, field]
    );

    const fieldValue = isVariant
      ? tasksFormStore.getVariantOnTaskCondition(indexTask, indexVariant, indexCondition)?.[field]
      : tasksFormStore.getConditionMetric(indexTask, indexCondition)?.[field];

    return (
      <Box sx={{ display: 'flex', alignItems: 'center', px: 1, gap: 0.5 }}>
        <TextFieldMultiplayerStyled
          value={fieldValue ?? ''}
          InputProps={{
            disabled: isRead,
            inputProps: { min: 0, style: { padding: '0 0 0 3px', textAlign: 'left', borderRadius: 0 } },
          }}
          onChange={handleChangeMultiplayer}
          type="number"
        />
        <Typography
          sx={(t) => ({ fontSize: t.typography.body1.fontSize, lineHeight: 0, top: -1, position: 'relative' })}
        >
          x
        </Typography>
      </Box>
    );
  }
);

export default ConditionMultiplayer;
